import api from "../api";

export default function getFirebaseUserInfo(userId) {
    return api.get(`/admin/users/info/${userId}`);
}
